import Organism from './organism';

export default Organism;
